export const minLengthValidator = (minLength) => (value) => value.length >= minLength;
export const lowerCaseValidator = () => (value) => new RegExp('[a-z]').test(value);
export const upperCaseValidator = () => (value) => new RegExp('[A-Z]').test(value);
export const numberValidator = () => (value) => new RegExp('[0-9]').test(value);
//# sourceMappingURL=validators.js.map